export default "__VITE_ASSET__Cls0UYq7__"